import { Download, MonitorSmartphone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { isStandalone, useInstallPrompt } from "@/lib/pwa";
import { SettingsSection } from "./SettingsSection";

const STEPS = [
  { id: "ios", title: "iPhone y iPad", text: "En Safari, toca Compartir y luego \u201cAgregar a inicio\u201d." },
  { id: "mac", title: "Mac", text: "En Safari, abre el men\u00fa Archivo y elige \u201cAgregar al Dock\u201d. En Chrome o Edge, usa el bot\u00f3n Instalar de la barra de direcciones." },
  { id: "win", title: "Windows y Android", text: "En Chrome o Edge, usa el bot\u00f3n Instalar de abajo o el \u00edcono de instalar en la barra de direcciones." },
];

export function InstallCard() {
  const { canInstall, install } = useInstallPrompt();
  const installed = isStandalone();
  return (
    <SettingsSection id="instalar" icon={MonitorSmartphone} title="Instalar Otium" desc="Ábrela como app, con su propio ícono y ventana.">
      {installed ? (
        <p className="text-sm text-emerald-700" data-testid="install-already">Ya estás usando Otium como app.</p>
      ) : (
        <>
          <ul className="grid gap-4 sm:grid-cols-3">
            {STEPS.map((s) => (
              <li key={s.id} className="rounded-xl border border-[#DDE1E8] p-4" data-testid={`install-steps-${s.id}`}>
                <p className="text-sm font-semibold text-[#1B2A4A]">{s.title}</p>
                <p className="mt-1 text-sm text-slate-600">{s.text}</p>
              </li>
            ))}
          </ul>
          {canInstall && (
            <Button onClick={install} className="mt-5 bg-[#1B2A4A] text-white hover:bg-[#2A3D63]" data-testid="install-button">
              <Download className="mr-2 h-4 w-4" /> Instalar
            </Button>
          )}
        </>
      )}
    </SettingsSection>
  );
}
